import { APPLY_PUBLIC_ORIGIN } from '@/lib/publicDomain';

/** Canonical public apply URL for a job posting. */
export function buildPublicPostingUrl(companySlug: string, postingId: string): string {
  const slug = companySlug.replace(/^\/+|\/+$/g, '');
  const id = postingId.replace(/^\/+|\/+$/g, '');
  return `${APPLY_PUBLIC_ORIGIN}/${slug}/${id}`;
}

/** Prefer a freshly computed URL when slug is known; fall back to stored URL. */
export function resolvePostingPublicUrl(
  posting: { id: string; landingPageUrl?: string },
  companySlug?: string | null,
): string {
  if (companySlug) {
    return buildPublicPostingUrl(companySlug, posting.id);
  }
  return posting.landingPageUrl ?? '';
}
